import { useMemo, useState } from 'react';
import { Button } from '@/components/ui/button';
import SalaryCsvUploadModal from '@/components/finance/salaries-import-csv/SalaryCsvUploadModal';
import { isSupportedSalaryCsvCategory } from '@/components/finance/salaries-import-csv/supportedSalaryCsvCategories';

type Department = {
  id: string;
  name: string;
};

type Category = {
  id: string;
  name: string;
};

interface Props {
  departments?: Department[];
  categories?: Category[];
  selectedDepartmentId: string;
  selectedCategoryId: string;
}

const PublicPaymentRequestCsvTriggers = ({
  departments,
  categories,
  selectedDepartmentId,
  selectedCategoryId,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedDepartment = departments?.find(
    (dept) => dept.id === selectedDepartmentId
  );

  const selectedCategory = categories?.find(
    (cat) => cat.id === selectedCategoryId
  );

  const shouldShowCsvTrigger = useMemo(() => {
    return isSupportedSalaryCsvCategory(selectedCategoryId);
  }, [selectedCategoryId]);

  if (!shouldShowCsvTrigger || !selectedDepartment || !selectedCategory) {
    return null;
  }

  return (
    <>
      <div className="rounded-md border border-dashed p-3">
        <div className="flex items-center justify-between gap-3">
          <p className="text-sm text-muted-foreground">
            Would you like to upload data from a CSV file?
          </p>
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => setIsOpen(true)}
          >
            Upload CSV
          </Button>
        </div>
      </div>

      <SalaryCsvUploadModal
        open={isOpen}
        onOpenChange={setIsOpen}
        departmentId={selectedDepartment.id}
        departmentName={selectedDepartment.name}
        categoryId={selectedCategory.id}
        categoryName={selectedCategory.name}
        paymentRequestId={null}
      />
    </>
  );
};

export default PublicPaymentRequestCsvTriggers;